<template lang="pug">
.calendar_header
  .header_block(v-for='(day, index) in daysOfWeek', :key='index')
    | {{ getDay(index) }}
</template>

<script>
import { format } from "date-fns";

export default {
  name: 'CalendarHeader',
  props: {
    days: {},
  },
  data() {
    return {
      daysOfWeek: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'],
    };
  },
  methods: {
    getDay(index) {
      return `${this.daysOfWeek[index]} (${format(this.days[index], 'DD.MM')})`;
    },
  },
};
</script>

<style scoped lang="stylus">
.calendar_header
  font-family: 'Open Sans', sans-serif;
  background #efefef
  display flex
  flex-direction row
  border-left 1px solid #aaaaaa
  border-top 1px solid #aaaaaa
  border-bottom 1px solid #aaaaaa
  font-size: 14px;
  font-weight bold;
  .header_block
    display flex
    justify-content center
    align-items center
    width 14.28571%;
    min-height 40px;
    border-right 1px solid #aaaaaa;
</style>



// WEBPACK FOOTER //
// CalendarHeader.vue?3aa96173